const calculateVatRate = (money, vatRate) => {
  if (typeof money === 'string') money = parseFloat(money);
  const salonVatRate = vatRate || 0;
  const value = money || 0;

  return Math.round((value / (1 + salonVatRate / 100)) * 100) / 100;
};

export default calculateVatRate;
